import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./upsize_ladder_type.js";
//#region src/upsize_ladder_type_helper.ts
var upsize_ladder_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case "price-option": return "Price Option";
		case "size-mod": return "Size Mod";
		case "item-swap": return "Item Swap";
	}
}
//#endregion
export { name, upsize_ladder_type_helper_exports };

//# sourceMappingURL=upsize_ladder_type_helper.js.map